<template>
    <div class='t_content_view'>
        
        <div class="t_search_box">
            <div class="t_search_select">
                <span style="color: #6D6D6D;">企微主体：</span>
                <el-select style="width: 180px;"  size="small" v-model="searchdata.corp_id" @change="changezt" clearable placeholder="请选择">
                   
                    <el-option v-for="(item,index) in corpList.data" 
                    :key="index"
                    :label="item.corp_name" :value="item.id" />
                </el-select>
            </div>
            <div class="t_search_select" >
                <img src="../assets/img/searchgray.png" style="width:14px" alt="">
                <el-input @input="searchinput" size="small" v-model="searchdata.title" placeholder="请输入任务名称"  clearable />
            </div> 
            <div class="t_search_select" style="margin-right:20px;margin-left:20px">
                <span style="color: #6D6D6D;">创建时间：</span>
                <el-date-picker
                    size="small" 
                    @change="changeTime"
                    v-model="choosetime.data"
                    value-format="YYYY-MM-DD HH:mm:ss"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                />
            </div>
            <el-button @click="resetsearch" color="#F1F3F9" type="primary" style="margin-bottom: 10px;">重置</el-button>
        </div>
        <div style="margin-top: 20px;margin-bottom: 20px;">
            <router-link to="/navtkyl/friendwelcomeadd"><el-button   color="#4F46E5" type="primary">新增欢迎语</el-button></router-link>
        </div>
        <el-table :header-cell-style="{ background: '#F1F3F9' }" :data="tableData.data" style="width: 100%" >
            <el-table-column prop="title" label="任务名称"  />
            <el-table-column prop="users" label="当前使用成员" >
                <template #default="scope">
                    <div v-if="scope.row.users!=null" style="display: flex;flex-wrap: wrap;align-items: center;">
                        <div style="margin-right: 10px;margin-bottom: 5px;" v-for="(item,index) in scope.row.users" :key="index">
                            <el-tag v-if="scope.row.showall?true:index<3?true:false"
                             type="success">{{ item.name }}</el-tag>
                        </div>
                        <span v-if="scope.row.users.length>3">
                            <el-button v-if="!scope.row.showall" type="text" @click="showallbtn(1,scope.row.id)">全部</el-button>
                            <el-button v-else type="text" @click="showallbtn(2,scope.row.id)">收起</el-button>
                        </span>
                        
                    </div>
                    
                </template>
            </el-table-column>
            <el-table-column prop="updated_at" label="更新时间"  />
            <el-table-column prop="" label="操作">
                <template #default="scope">
                    <el-button style="color:#4F46E5" size="small" type="text" @click="openmodel(scope.row.id)">编辑</el-button>
                    <el-button style="color:#f56c6c" size="small" type="text" @click="delitem(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <pagechange :total="total" :nowpage="searchdata.page" @page_change="page_change" />
    </div>
</template>

<script setup>
import { ref, reactive, provide, onBeforeMount, onMounted, watch ,inject} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { ElMessage,ElMessageBox } from 'element-plus'
//导入子组件
import pagechange from '../components/pagechange.vue'
import { WelcomeList,DelWelcome ,newwelcomelist,newgetpeo,newdelwelcome,newgetcomp2} from '@/assets/js/common.js'
//路由跳转
const router = useRouter()
//获取数据
const route = useRoute()
//动态获取接口地址
const _url2 = inject('_url2')

onMounted(() => {
    console.log('onMounted')
    getallpeolist()
    //获取列表
    getlist()
    //获取企微主体下拉
    getcorplist()
})
//企微主体下拉
const corpList = reactive({
    data:[]
})
//获取企微主体下拉
const getcorplist = ()=>{
    newgetcomp2().then((response)=>{
        if (response.data.msg.code == 0) {
            corpList.data = response.data.data
            console.log('企微主体下拉')
            console.log(corpList.data)
        }
    })
}
//所有成员下拉数组
const allpeolist = reactive({
    data:[]
})
//获取所有成员下拉
const getallpeolist = ()=>{
    newgetpeo().then((response)=>{
        if (response.data.msg.code == 0) {
             console.log('成员==')
             console.log(response.data)
            allpeolist.data = response.data.data
        }
    })
}
//翻译成员
const fanyipeople = (id)=>{
    for(var x = 0;x<allpeolist.data.length;x++){
        if(allpeolist.data[x].id==id){
            return allpeolist.data[x].name
        }
    }
}
//搜索内容
const searchdata  = reactive({
    title:'',
    page:1,
    page_size:20,
    start:'',
    end:'',
    corp_id:''
})
//监听搜索文本框内容变化
const searchinput = (e)=>{
    console.log(e)
    searchdata.title = e
    searchdata.page=1
    getlist()
}
//搜索时间
const choosetime = reactive({
    data:[]
})
//监听时间改变
const changeTime = (e)=>{
    console.log(e)
    if(e==null){
        searchdata.start = ''
        searchdata.end = ''
    }else{
        searchdata.start = e[0]
        searchdata.end = e[1]
    }
    searchdata.page=1
    getlist()
}
//重置
const resetsearch = ()=>{
    searchdata.title=''
    searchdata.page=1
    searchdata.start=''
    searchdata.end=''
    choosetime.data = []
    searchdata.corp_id = ''
    getlist()
}


//列表内容
const tableData = reactive({
    data:[]
})
//总数
const total = ref(0)
//监听分页
const page_change = (val)=>{
    searchdata.page = val
    //人员列表
    getlist()
}

//获取列表
const getlist = ()=>{
    newwelcomelist(searchdata).then((response)=>{
        console.log('获取列表')
        console.log(response)
        tableData.data = response.data.data.data
        for(var x = 0;x<tableData.data.length;x++){
            tableData.data[x].showall = false
        }
        total.value = response.data.data.total
    })
}
//是否显示全部成员
const showallbtn = (type,id)=>{
    for(var x = 0;x<tableData.data.length;x++){
        if(tableData.data[x].id==id){
            if(type==1){
                //显示全部
                tableData.data[x].showall = true
            }else{
                //显示3个
                tableData.data[x].showall = false
            }
        }
    }
    
}
//删除
const delitem = (id)=>{
    ElMessageBox.confirm(
    '是否确认删除',
    '提示',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
        newdelwelcome({id:id}).then((response)=>{
            if(response.data.msg.code==0){
                ElMessage({
                    type: 'success',
                    message: '删除成功',
                })
                getlist()
            }
        })
      
    })
    .catch(() => {
      ElMessage({
        type: 'info',
        message: '已取消',
      })
    })
}
//编辑跳转
const openmodel = (id)=>{
    router.push({ path: '/navtkyl/friendwelcomeadd',query:{id:id} })
}
//企微主体下拉变化
const changezt = (val)=>{
    console.log(val)
    searchdata.corp_id = val
    searchdata.page = 1
    getlist()

}
</script>

<style scoped>
:deep( .t_search_box .el-input__wrapper) {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
:deep(.t_search_select .el-select__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
</style>